import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import TableView from '../../Components/TableView';

// const Wrapper = styled.div``;

const FormatTable = ({ data }) => {
  const columns = [
    {
      title: 'Format Id',
      dataIndex: 'format_id',
      key: 'format_id',
      render: (value) => value || '-',
      align: 'center',
      width: 100,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (value) => value || '-',
      align: 'center',
    },
    {
      title: 'Number of Digests',
      dataIndex: 'count',
      key: 'count',
      render: (value) => value || '-',
      align: 'center',
    },
  ];
  return (
    <>
      <TableView tableColumns={columns} data={data} />
    </>
  );
};

FormatTable.propTypes = {
  data: PropTypes.object,
};

export default FormatTable;
